export const _static_messages = {
    DEFAULT  : "Something went wrong!",
    DISPATCH_FILES  : "Successfully file uploaded to server",
    SEND_MAIL: "Email sent successfully"
}